import React, { Component } from "react";
import "../Resume/MakeResume";
import Card from "../../../Assets/img/credit-card.png";
import Footer from "../../Hoc/Footer";
import axios from "axios";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Header from "../../Hoc/Header";

export default class PayJob extends Component {
  constructor() {
    super();
    this.state = {
      loader: false,
      user: [],
      link: "",
      codeStatus: null,
      actualCode: "",
      discount: "",
      codeLoader: false,
      giftCode: "",
    };

    this.getPaymentLink = this.getPaymentLink.bind(this);
    this.goHome = this.goHome.bind(this);
  }

  componentDidMount() {
    this.getUser();
  }

  goHome() {
    this.props.history.push("/Home");
  }

  getUser() {
    axios
      .get(
        `https://arianaapp.arianaapply.com/api/V1/get-user/${localStorage.getItem(
          "token"
        )}`
      )
      .then((response) => {
        console.log("user", response);
        this.setState({ user: response.data });
      });
  }

  getPaymentLink() {
    this.setState({ loader: true });
    axios
      .post("https://arianaapp.arianaapply.com/api/V1/payment-pwa-apply-job", {
        user_id: this.state.user._id,
        email: this.state.user.email,
        mobile: this.state.user.phone,
        code: this.state.actualCode
      })
      .then((res) => {
        console.log(res);
        this.setState(
          {
            loader: false,
            link: res.data,
          },
          () => {
            setTimeout(() => {
              window.open(`${this.state.link}`);
            });
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }

  submitGiftCode() {
    this.setState({ codeLoader: true });
    axios
      .post("https://arianaapp.arianaapply.com/api/V1/check-discount-code", {
        code: this.state.giftCode,
      })
      .then((res) => {
        if (res.data.status === 404) {
          this.setState({ codeStatus: false, codeLoader: false });
        } else {
          this.setState({
            codeStatus: true,
            discount: res.data.data.discount,
            actualCode: this.state.giftCode,
            codeLoader: false,
          });
        }
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  render() {
    return (
      <div className="pay">
        <Header title={"پرداخت"} />

        <div className="pay-box">
          <img src={Card} alt="card" />
          <span>پرداخت</span>
          <p>
            مبلغ 200 هزار تومان جهت ساخت رزومه و ثبت نام در سامانه کاریابی خارجی
            (طبق تعرفه وزارت تعاون کار و رفاه اجتماعی) پرداخت نمایید.
          </p>
          <div className="pay-gift-code">
            <label>کد تخفیف:</label>
            <div className="gift-code-wrapper">
              <div className="gift-code-input-wrapper">
                <input
                  type="text"
                  value={this.state.giftCode}
                  name="giftCode"
                  onChange={(e)=> this.setState({ giftCode: e.target.value })}
                  placeholder="کد تخفیف خود را وارد کنید..."
                />
                <span className={this.state.codeStatus === true ? 'success-code' : 'danger-code'}>
                  {
                    this.state.codeStatus === true ?
                    `کد تخفیف ${this.state.discount} درصدی شما با موفقیت ثبت شد `:
                    this.state.codeStatus === false ?
                    'کد تخفیف وارد شده صحیح نمیباشد'
                    : null
                  }
                </span>
              </div>
              <button onClick={()=> this.submitGiftCode()}>{this.state.codeLoader === true ? <Loader type="TailSpin" color="#251d23" height={20} width={20} /> : 'ثبت کد'}</button>
            </div>
          </div>
          <button className="pay-btn" onClick={this.getPaymentLink}>
            {this.state.loader === false ? (
              <span>پرداخت</span>
            ) : (
              <Loader type="TailSpin" color="white" height={30} width={30} />
            )}
          </button>
        </div>

        <Footer />
      </div>
    );
  }
}
